// https://medium.com/@nazmifeeroz/how-to-use-react-usecontext-and-usestate-hooks-as-a-global-store-1b4f1898034f
// import type { IFiles, IFolders } from "@/types/interfaces";
import {
  useState,
  createContext,
//   type ReactNode,
  type SetStateAction,
} from "react";

interface IUserDetails {
  userId: string;
  username: string;
  rating: number;
  streak: number;
}

interface IOnlinePlayers {
  username: string;
  rating: number;
}

interface IDataProvider {
  children: React.ReactNode;
}

interface ICreateContext {
    user: IUserDetails;
    setUser: React.Dispatch<SetStateAction<IUserDetails>>;
    onlinePlayersDetails: IOnlinePlayers[],
    setOnlinePlayersDetails: React.Dispatch<SetStateAction<IOnlinePlayers[]>>; 
    onlinePlayersCount: number;
    setOnlinePlayersCount: React.Dispatch<SetStateAction<number>>;

}

export const DriveContext = createContext<ICreateContext | null>(null);

export function DriveProvider({ children }: IDataProvider) {
  const [user, setUser] = useState<IUserDetails>({
    userId: "",
    username: "",
    rating: 0,
    streak: 0
  });
  const [onlinePlayersDetails, setOnlinePlayersDetails] = useState<IOnlinePlayers[]>([]);
  const [onlinePlayersCount, setOnlinePlayersCount] = useState<number>(0);

//   const [files, setFiles] = useState<IFiles[]>([]);
//   const [totalSize, setTotalSize] = useState<number>(0);

  return (
    <DriveContext.Provider value={{
          // files,
          // folders,
          // setFolders,
          // setFiles,
        user,
        onlinePlayersCount,
        onlinePlayersDetails,
        setUser,
        setOnlinePlayersCount,
        setOnlinePlayersDetails
      }}
    >
      {children}
    </DriveContext.Provider>
  );
}
